module.exports = __webpack_public_path__ + "static/media/subscription-success-certification.6e7645b2.png";